import React, { memo, useEffect } from 'react';

import styles from './FlatTreeSelect.module.scss';

interface ITreeSelectProps {
	options: string[];
	selectRef: React.RefObject<HTMLSelectElement>;
	defaultValue?: string;
	onChange?: (value: string) => void;
}

const FlatTreeSelect = ({
	options,
	selectRef,
	defaultValue,
	onChange,
}: ITreeSelectProps) => {
	const onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
		if (onChange) {
			onChange(event.target.value);
		}
	};

	useEffect(() => {
		if (options.length && onChange) {
			onChange(options[0]);
		}
	}, [options, onChange]);

	return (
		<div className={styles.wrapper}>
			<select
				ref={selectRef}
				className={styles.select}
				onChange={onChangeHandler}
				required
			>
				{options.map((value, index) => {
					return (
						<option
							key={`${index}-${value}`}
							defaultValue={!!defaultValue && defaultValue === value.toString() ? value : undefined}
							value={value}
						>
							{value}
						</option>
					);
				})}
			</select>
		</div>
	);
};

export default memo(FlatTreeSelect);
